import script from "./AgentLicences.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentLicences.vue?vue&type=script&setup=true&lang=js"

import "./AgentLicences.vue?vue&type=style&index=0&id=4f717dea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f717dea"]])

export default __exports__